import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { createExpense } from '../api/expensesApi';

// SignalR's UpdateExpenseTable handles cache invalidation — useExpensesByJob
// listens and refetches, so no optimistic write here.
export default function useCreateExpense() {
    return useMutation({
        mutationFn: createExpense,
        onSuccess: () => toast.success('Expense created'),
        onError: (err) => toast.error(err?.message ?? 'Failed to create expense'),
    });
}
